import { render } from "./Tem018.vue?vue&type=template&id=7a3f53ca"
import script from "./Tem018.vue?vue&type=script&lang=js"
export * from "./Tem018.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__